import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, Calendar } from "lucide-react";
import { motion } from "framer-motion";

export default function BookingSuccess() {
  const { state } = useLocation();
  const name = state?.name || "Friend";
  const date = state?.date;
  const time = state?.time;
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-[#F4F6FB] grid place-items-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
        className="max-w-lg w-full bg-white border border-slate-200 rounded-3xl p-8 md:p-10 text-center shadow-[0_30px_80px_-50px_rgba(10,25,48,0.4)]"
        data-testid="booking-success"
      >
        <div className="w-14 h-14 mx-auto rounded-full bg-[#0066CC]/10 grid place-items-center">
          <CheckCircle2 className="w-8 h-8 text-[#0066CC]" strokeWidth={1.5} />
        </div>
        <h1 className="font-display text-3xl md:text-4xl text-[#0A1930] mt-6 tracking-tight">You're booked, {name.split(" ")[0]}.</h1>
        <p className="mt-3 text-slate-600">We can't wait to talk with you.</p>
        {date && time && (
          <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-slate-200 px-4 py-2 text-sm text-[#0A1930]">
            <Calendar className="w-4 h-4 text-[#0066CC]" />
            <span>{date} · {time} ET</span>
          </div>
        )}
        <p className="mt-6 text-sm text-slate-500">A confirmation has been sent to your email and phone. You'll receive a friendly reminder before your call.</p>
        <Link to="/" className="mt-8 inline-block bg-[#0A1930] text-white rounded-full px-6 py-3 text-sm hover:bg-[#0F2348]" data-testid="success-home-cta">
          Back to home
        </Link>
      </motion.div>
    </div>
  );
}
